import React from 'react';
import { motion } from 'framer-motion';
import { FiTarget, FiHeart, FiRefreshCcw } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Services = () => {
  const services = [
    {
      icon: FiTarget,
      title: "Beginner Lessons",
      desc: "Start your driving journey with confidence. We teach you the fundamentals of automatic driving in a safe, stress-free environment."
    },
    {
      icon: FiHeart,
      title: "Nervous Drivers",
      desc: "Anxious about driving? Our highly patient approach is specifically tailored to help you overcome fears and build rock-solid confidence."
    },
    {
      icon: FiRefreshCcw,
      title: "Refresher Courses",
      desc: "Already have a license but haven't driven in a while? We'll help you brush up on your skills and get back on the road safely."
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-brandOrange font-bold tracking-wider uppercase text-sm mb-2">Our Services</h2>
          <h3 className="text-4xl font-extrabold text-royal">Tailored Automatic Tuition</h3>
          <div className="w-24 h-1 bg-brandOrange mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow border-b-4 border-royal"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mb-6 text-brandOrange">
                <SafeIcon icon={service.icon} className="w-8 h-8" />
              </div>
              <h4 className="text-2xl font-bold text-royal mb-4">{service.title}</h4>
              <p className="text-gray-600 leading-relaxed">
                {service.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;